/**
 * WEBE-26603 — experiment exposure event. Reuses galleria's existing Amplitude `logEvent`.
 * `logEvent` does NOT check consent (`_document` always installs the `window.amplitude` loader stub, and
 * the SDK stays live after withdrawal), so callers must: AbExposure only calls this with A/B consent.
 * The variant comes from the visitor's `ab_bucket` cookie (assigned at consent, forwarded by Fastly as
 * `X-AB-Bucket`); this only records that a variant was shown.
 */
import { logEvent } from '@/utils/analytics';

type Exposure = { experimentKey: string; variant: string };

export const trackExposure = ({ experimentKey, variant }: Exposure) => {
  logEvent('experiment_exposure', { experiment_key: experimentKey, variant });
};
